module.exports = __webpack_public_path__ + "static/media/desliza-leer-mas.1f5b8347.png";